var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field" }, [
    !_vm.hide_name
      ? _c("div", { staticClass: "name" }, [
          _vm._v(_vm._s(_vm.name ? _vm.name + ":" : ""))
        ])
      : _vm._e(),
    _c(
      "div",
      {
        class: !_vm.hide_name
          ? "value"
          : _vm.hide_name_class
          ? _vm.hide_name_class
          : ""
      },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }